export const Cookie = {
    BCAI_EMAIL: '_bcai_el',
    BCAI_PLATFORM: '_bcai_pl',
    BCAI_PLAN_LEAD_SOURCE: '_bcai_pl_ls',
    BCAI_PLAN_PRODUCT_TYPE: '_bcai_pl_pt',
    BCAI_SHOPIFY_APP_INSTALLED: '_bcai_sai',
    SIDEBAR_STATE: 'sidebar_state',
}

export const LocalStorageKey = {
    BANNER_DISMISSED_KEY: 'data_backdated_banner_dismissed',
    BCAI_CALL_BOOKED: '_bcai_ocb',
    CLIENT_HASH: 'clientHash',
    JWT: 'jwt',
    SELECTED_METRIC: 'selectedMetric',
    VERIFYING_TOKEN_KEY: 'isVerifyingMagicLink',
    MULTI_STOREFRONT_OPTIN_SHOWN: 'multi_storefront_optin_shown',
}

export const SessionStorageKey = {
    FROM_SIGNUP: 'fromSignup',
    SALES_CLIENT_META_SETUP_COMPLETED: 'sales_client_meta_setup_completed',
    RETURN_TO: 'returnTo',
}
